/**
 * Convertit une URL d'image relative en URL absolue pour les meta tags Open Graph
 * Facebook nécessite des URLs absolues pour les images
 * 
 * @param {string} imagePath - Chemin relatif ou absolu de l'image
 * @returns {string} URL absolue de l'image
 */
export const getAbsoluteImageUrl = (imagePath) => {
  if (!imagePath) {
    return null;
  }

  // Si l'URL est déjà absolue (commence par http:// ou https://), la retourner telle quelle
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Si l'URL commence par //, ajouter https:
  if (imagePath.startsWith('//')) {
    return `https:${imagePath}`;
  }

  // Déterminer le domaine de base
  // En SSR, utiliser REACT_APP_BASE_URL (défini par le serveur SSR) ou une valeur par défaut
  // En client, utiliser window.location.origin si disponible
  let baseUrl = 'https://www.arras.fr'; // Valeur par défaut
  
  if (typeof window !== 'undefined' && window.location) {
    // Côté client : utiliser window.location.origin
    baseUrl = window.location.origin;
  } else {
    // Côté serveur SSR : utiliser REACT_APP_BASE_URL défini par le serveur
    // Note: process.env.REACT_APP_BASE_URL est défini dynamiquement par le serveur SSR
    // avant le renderToString, donc il devrait être disponible
    baseUrl = process.env.REACT_APP_BASE_URL || 'https://www.arras.fr';
  }

  // Si le chemin commence par /, c'est un chemin absolu depuis la racine
  if (imagePath.startsWith('/')) {
    return `${baseUrl}${imagePath}`;
  }

  // Sinon, c'est un chemin relatif, l'ajouter à la base
  return `${baseUrl}/${imagePath}`;
};

/**
 * Obtient l'URL de l'image par défaut pour Open Graph
 * @returns {string} URL absolue de l'image par défaut
 */
export const getDefaultOgImage = () => {
  // Image par défaut pour Open Graph : logo de la ville d'Arras
  const defaultImage = process.env.REACT_APP_DEFAULT_OG_IMAGE || '/images/logo-ville-arras.png';
  return getAbsoluteImageUrl(defaultImage);
};

/**
 * Dimensions recommandées pour les images Open Graph Facebook
 * Facebook recommande : 1200x630 pixels (ratio 1.91:1)
 */
export const OG_IMAGE_DIMENSIONS = {
  width: '1200',
  height: '630',
  type: 'image/png' // ou 'image/jpeg' selon votre image
};

